import React from 'react';
import { AiAnalysisType } from '../../../models/AiAnalysisType';

type AiAnalysisLabelsProp = {
    aiAnalysisType: AiAnalysisType;
    onLabelTypeChange: (
        aiAnalysisTypeId: string,
        type: number,
        checked: boolean
    ) => void;
};
export const AiAnalysisLabels: React.FC<AiAnalysisLabelsProp> = (props) => {
    const { aiAnalysisType, onLabelTypeChange } = props;

    return (
        <>
            {aiAnalysisType.labels.map((label) => {
                return (
                    <label key={label.id}>
                        <input
                            type="checkbox"
                            onChange={(e) =>
                                onLabelTypeChange(
                                    aiAnalysisType.aiAnalysisTypeId,
                                    label.id,
                                    e.target.checked
                                )
                            }
                            defaultChecked={false}
                        />
                        {label.nameJa}
                    </label>
                );
            })}
        </>
    );
};
